export enum SERVICE_FREQUENCY {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  CUSTOM_DAYS = 'CUSTOM_DAYS',
}
